import { c as _c } from "react/compiler-runtime";
import { IconClose } from '@endurancewarranty/icons';
import { cx, getConditionalValue, Flex, Text } from '@endurancewarranty/ui';
import type { TErrorContext } from '@lib/states/error/errorAtom';
import type { FC } from 'react';
type Props = {
  errorContext: TErrorContext;
  onClose?: () => void;
};
export const ErrorModalHeader: FC<Props> = t0 => {
  const $ = _c(15);
  const {
    errorContext,
    onClose
  } = t0;
  const t1 = errorContext === "payment";
  let t2;
  if ($[0] !== errorContext || $[1] !== t1) {
    t2 = getConditionalValue([["Sorry, there was an issue processing payment information", t1], ["Sorry, but this request is not valid", errorContext === "bad_request"], ["Please sign-in again", errorContext === "unauthenticated"], ["Access denied", errorContext === "unauthorized"]], "Sorry, but something went wrong");
    $[0] = errorContext;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const headerText = t2;
  const t3 = errorContext === "bad_request" || errorContext === "payment";
  const t4 = errorContext === "default";
  const t5 = errorContext === "unauthenticated" || errorContext === "unauthorized";
  let t6;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = cx("absolute left-0 top-0 h-16 w-full rounded-tl-2xl rounded-tr-2xl", {
      "bg-blue-500": t3,
      "bg-red-500": t4,
      "bg-teal-500": t5
    });
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== headerText) {
    t7 = <Text.Header color={0} margin="ml-4" size="sm" fontWeight="medium">{headerText}</Text.Header>;
    $[7] = headerText;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onClose) {
    t8 = <IconClose className="absolute right-4 hover:cursor-pointer" width={20} color="#FFF" onClick={onClose} />;
    $[9] = onClose;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t9 = <Flex className={t6} items="center">{t7}{t8}</Flex>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};